/**
 * 角色代碼對應
 */
export enum RoleEnum {
  /**
   *
   * R9263 馬來西亞Admin：行政人員（含科、部主管）
   */
  ADMIN = 'ADMIN',
  /**
   *
   * R9261 馬來西亞Admin2：行政人員（含科、部主管）
   */
  ADMIN2 = 'ADMIN2',
  /**
   * R9202 馬來西亞 董事長
   */
  CHAIRMAN = 'CHAIRMAN',
  /**
   * R9203 馬來西亞 總經理
   */
  GENERAL_MGR = 'GENERAL_MGR',

  /**
   * R9211 馬來西亞 MARKETING_OFFICER
   */
  MARKETING_OFFICER = 'MARKETING_OFFICER',

  /**
   * R9212 馬來西亞 Marketing maanager
   */
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',

  /**
   *
   * R9214 馬來西亞 業務人員
   */
  SALES_PERSON = 'SALES_PERSON',

  /**
   * R9215 馬來西亞 業務科主管
   */
  SALES_MANAGER = 'SALES_MANAGER',
  /**
   *
   * R9221 馬來西亞Credit Officer
   */
  CREDIT_OFFICER = 'CREDIT_OFFICER',

  /**
   * R9222 馬來西亞Credit_Mgr
   */
  CREDIT_MANAGER = 'CREDIT_MANAGER',

  /**
   * R9223 馬來西亞 消金廠審人員
   */
  FACTORY_INSPECTOR = 'FACTORY_INSPECTOR',

  /**
   * R9224 馬來西亞 廠審科主管
   */
  FACTORY_INSPECT_MANAGER = 'FACTORY_INSPECT_MANAGER',

  /**
   * R9225 馬來西亞 個審人員
   */
  PERSONNEL_INSPECTOR = 'PERSONNEL_INSPECTOR',

  /**
   * R9231 馬來西亞客服人員（不含科.部主管）
   */
  CS_OFFICER = 'CS_OFFICER',

  /**
   * R9232 馬來西亞客服主管（含科.部主管）
   */
  CS_MGR = 'CS_MGR',

  /**
   * R9234 馬來西亞 消金客服人員
   */
  CUSTOMER_SERVICE_PERSONNEL = 'CUSTOMER_SERVICE_PERSONNEL',

  /**
   * R9241 馬來西亞 催收人員
   */
  COLLECTION_OFFICER = 'COLLECTION_OFFICER',

  /**
   * R9251 馬來西亞 財會人員
   */
  FA_OFFICER = 'FA_OFFICER',

  /**
   * R9247 Call center
   */
  CALL_CENTER = 'CALL_CENTER',
}
